import { CouponScopeGroup, CouponScopeNamespace } from './constants';
import { isCouponTemplateSubtitleParams } from './utils';
const getRewardFromCouponReward = ({ formatCurrency, t }, { couponReward }) => {
    const { scope, limitedToOneItem, minimumSubtotal, freeShipping } = couponReward;
    const namespace = scope?.namespace;
    const group = scope?.group?.name;
    const entityId = scope?.group?.entityId;
    if (!freeShipping && minimumSubtotal) {
        return t('loyalty-coupon-names.reward.minimum-subtotal', {
            amount: formatCurrency(minimumSubtotal),
        });
    }
    else if (namespace === CouponScopeNamespace.Stores) {
        if (group === CouponScopeGroup.Product && entityId) {
            return t('loyalty-coupon-names.reward.item-product');
        }
        else if (group === CouponScopeGroup.Collection && entityId) {
            return t('loyalty-coupon-names.reward.item-collection');
        }
        else if (limitedToOneItem) {
            return t('loyalty-coupon-names.reward.lowest-priced-item');
        }
        else {
            return t('loyalty-coupon-names.reward.all-stores');
        }
    }
    else if (namespace === CouponScopeNamespace.Bookings) {
        if (group === CouponScopeGroup.Service && entityId) {
            return t('loyalty-coupon-names.reward.item-service');
        }
        else if (limitedToOneItem) {
            return t('loyalty-coupon-names.reward.lowest-priced-item');
        }
        else {
            return t('loyalty-coupon-names.reward.all-bookings');
        }
    }
    else if (namespace === CouponScopeNamespace.Events) {
        if (group === CouponScopeGroup.Ticket && entityId) {
            return t('loyalty-coupon-names.reward.item-ticket');
        }
        else if (group === CouponScopeGroup.Ticket && !entityId && !limitedToOneItem) {
            return t('loyalty-coupon-names.reward.all-tickets');
        }
        else if (group === CouponScopeGroup.Event && entityId) {
            return t('loyalty-coupon-names.reward.item-event');
        }
        else if (limitedToOneItem) {
            return t('loyalty-coupon-names.reward.lowest-priced-item');
        }
        else {
            return t('loyalty-coupon-names.reward.all-events');
        }
    }
    else if (namespace === CouponScopeNamespace.PricingPlans) {
        if (group === CouponScopeGroup.Plan && entityId) {
            return t('loyalty-coupon-names.reward.item-plan');
        }
        else {
            return t('loyalty-coupon-names.reward.all-plans');
        }
    }
    else if (namespace === CouponScopeNamespace.Restaurants) {
        if (group === CouponScopeGroup.Menu && entityId) {
            return t('loyalty-coupon-names.reward.item-menu');
        }
        else if (group === CouponScopeGroup.MenuItem && entityId) {
            return t('loyalty-coupon-names.reward.item-menu-item');
        }
        else if (group === CouponScopeGroup.MenuSection && entityId) {
            return t('loyalty-coupon-names.reward.item-menu-section');
        }
        else if (limitedToOneItem) {
            return t('loyalty-coupon-names.reward.lowest-priced-item');
        }
        else {
            return t('loyalty-coupon-names.reward.all-restaurants');
        }
    }
    else if (namespace === CouponScopeNamespace.OnlinePrograms) {
        if (group === CouponScopeGroup.Program && entityId) {
            return t('loyalty-coupon-names.reward.item-program');
        }
        else {
            return t('loyalty-coupon-names.reward.all-online-programs');
        }
    }
    else {
        return t('loyalty-coupon-names.reward.all-fallback');
    }
};
const getRewardFromCouponTemplate = ({ formatCurrency, t }, { coupon, referenceCoupon }) => {
    const { specification, displayData } = coupon;
    const namespace = specification?.scope?.namespace;
    const group = referenceCoupon
        ? specification?.scope?.name
        : specification?.scope?.group?.name;
    if (referenceCoupon && specification?.name) {
        return t('loyalty-coupon-names.reward.item', {
            displayName: specification.name,
        });
    }
    else if (displayData?.name) {
        return t('loyalty-coupon-names.reward.item', {
            displayName: displayData.name,
        });
    }
    else if (!specification?.freeShipping && specification?.minimumSubtotal) {
        return t('loyalty-coupon-names.reward.minimum-subtotal', {
            amount: formatCurrency(specification.minimumSubtotal),
        });
    }
    else if (namespace && specification?.limitedToOneItem) {
        return t('loyalty-coupon-names.reward.lowest-priced-item');
    }
    else if (namespace === CouponScopeNamespace.Stores) {
        return t('loyalty-coupon-names.reward.all-stores');
    }
    else if (namespace === CouponScopeNamespace.Bookings) {
        return t('loyalty-coupon-names.reward.all-bookings');
    }
    else if (namespace === CouponScopeNamespace.Events && group === CouponScopeGroup.Ticket) {
        return t('loyalty-coupon-names.reward.all-tickets');
    }
    else if (namespace === CouponScopeNamespace.Events) {
        return t('loyalty-coupon-names.reward.all-events');
    }
    else if (namespace === CouponScopeNamespace.PricingPlans) {
        return t('loyalty-coupon-names.reward.all-plans');
    }
    else if (namespace === CouponScopeNamespace.OnlinePrograms) {
        return t('loyalty-coupon-names.reward.all-online-programs');
    }
    else {
        return t('loyalty-coupon-names.reward.all-fallback');
    }
};
export const getReward = (context, subtitleParams) => {
    if (isCouponTemplateSubtitleParams(subtitleParams)) {
        return getRewardFromCouponTemplate(context, subtitleParams);
    }
    else {
        return getRewardFromCouponReward(context, subtitleParams);
    }
};
//# sourceMappingURL=getReward.js.map